export default "__VITE_ASSET__Gj_0a$9U__"